import { appInfo } from '../config/appinfo'

const fetchWithCredentials = async (url: string, options = {}) => {
  const response = await fetch(url, {
    credentials: 'include',
    ...options,
  })
  if (!response.ok) {
    throw new Error(`Failed to fetch: ${response.statusText}`)
  }
  return response.json()
}

export const chatAPI = {
  getConversations: (exerciseId?: string) => {
    const params = exerciseId ? `?exercise_id=${exerciseId}` : ''
    return fetchWithCredentials(`${appInfo.apiDomain}/api/lab-chat/conversations${params}`)
  },

  getConversation: (conversationId: string) =>
    fetchWithCredentials(`${appInfo.apiDomain}/api/lab-chat/conversations/${conversationId}`),

  getConversationProgress: (conversationId: string) =>
    fetchWithCredentials(`${appInfo.apiDomain}/api/lab-chat/conversations/${conversationId}/progress`),

  deleteConversation: (conversationId: string) =>
    fetch(`${appInfo.apiDomain}/api/lab-chat/conversations/${conversationId}`, {
      method: 'DELETE',
      credentials: 'include'
    }),

  downloadTranscript: (conversationId: string) =>
    fetch(`${appInfo.apiDomain}/api/lab-chat/conversations/${conversationId}/transcript`, {
      credentials: 'include'
    }),
  
  streamMessage: (body: any, signal?: AbortSignal) =>
    fetch(`${appInfo.apiDomain}/api/lab-chat/message/stream`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      signal,
      body: JSON.stringify(body)
    })
}

export interface LabLivekitToken {
  token: string
  url: string
  room: string
  identity: string
  conversation_id: string
}

export const labLiveKitAPI = {
  getToken: (
    exerciseId: string | number,
    conversationId?: string | null,
    teachingMode?: 'guide' | 'assist'
  ): Promise<LabLivekitToken> => {
    const params = new URLSearchParams({ exercise_id: String(exerciseId) })
    if (conversationId) params.set('conversation_id', conversationId)
    if (teachingMode) params.set('teaching_mode', teachingMode)
    return fetchWithCredentials(
      `${appInfo.apiDomain}/api/lab/livekit-token?${params.toString()}`
    )
  }
}
